const mkCol = (key, label, { type = 'string', sorted = false, headerCls = '', cellCls = '', fixed = false } = {}) => ({
  key,
  label,
  type,
  sorted,
  fixed,
  headerClassName: headerCls,
  cellClassName: cellCls,
})

// La suma de anchos de la variante con médico debe ser <= 800px para no
// generar scroll horizontal: es el mismo min-w del wrapper de CuentasTable.
const COL_W = {
  RAZON_SOCIAL: 'w-[170px] min-w-[170px] max-w-[170px] shrink-0 grow-0',
  CUIT: 'w-[130px] min-w-[130px] max-w-[130px] shrink-0 grow-0',
  CONTRATO: 'w-[110px] min-w-[110px] max-w-[110px] shrink-0 grow-0',
  ESTADO: 'w-[100px] min-w-[100px] max-w-[100px] shrink-0 grow-0',
  ADMINISTRADOR: 'w-[110px] min-w-[110px] max-w-[110px] shrink-0 grow-0',
  MEDICO: 'w-[220px] min-w-[220px] max-w-[220px] shrink-0 grow-0',
  SUBIR_DOCUMENTO: 'w-[30px] min-w-[30px] max-w-[30px] shrink-0 grow-0',
  ACCIONES: 'w-[30px] min-w-[30px] max-w-[30px] shrink-0 grow-0',
}

const mkTextCol = (key, label, sorted = false) =>
  mkCol(key, label, {
    type: 'component',
    sorted,
    headerCls: `${COL_W[key]} truncate text-left`,
    cellCls: `${COL_W[key]} text-left`,
  })

// Columnas comunes a ambas variantes de la grilla
const cuentasColsComunes = [
  mkTextCol('RAZON_SOCIAL', 'Razón social', true),
  mkTextCol('CUIT', 'CUIT', true),
  mkTextCol('CONTRATO', 'Contrato', true),
  mkTextCol('ESTADO', 'Estado'),
  mkTextCol('ADMINISTRADOR', 'Administrador'),
]

const cuentasAccionesCol = mkCol('acciones', '', {
  type: 'component',
  headerCls: `${COL_W.ACCIONES} text-center`,
  cellCls: `${COL_W.ACCIONES} text-center`,
})

// Caso 1: ninguna cuenta tiene perfil médico
export const cuentasBaseColumns = [...cuentasColsComunes, cuentasAccionesCol]

// Caso 2: al menos una cuenta tiene perfil médico
export const cuentasConMedicoColumns = [
  ...cuentasColsComunes,
  mkTextCol('MEDICO', 'Médico'),
  mkCol('SUBIR_DOCUMENTO', '', {
    type: 'component',
    headerCls: `${COL_W.SUBIR_DOCUMENTO} text-center`,
    cellCls: `${COL_W.SUBIR_DOCUMENTO} text-center`,
  }),
  cuentasAccionesCol,
]

/**
 * Selecciona la configuración de columnas según si alguna cuenta tiene perfil médico.
 * @param {boolean} conMedico - true si al menos una cuenta tiene perfil médico
 * @returns {Array} Columnas de la grilla
 */
export const getCuentasColumns = (conMedico) => (conMedico ? cuentasConMedicoColumns : cuentasBaseColumns)
